import { IconProps } from "../../../types/style";

const DashboardIcon = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.1645 10.3355H10.8318C9.91278 10.3355 9.16542 11.0829 9.16542 12.0019V15.3346C9.16542 16.2536 9.91278 17.0009 10.8318 17.0009H14.1645C15.0835 17.0009 15.8308 16.2536 15.8308 15.3346V12.0019C15.8308 11.0829 15.0835 10.3355 14.1645 10.3355ZM10.8318 15.3346V12.0019H14.1645V15.3346H10.8318ZM20.8299 6.77286V3.6701C20.8299 3.20936 20.4566 2.83693 19.9967 2.83693C19.5368 2.83693 19.1635 3.20936 19.1635 3.6701V5.64223L14.8285 2.71612C13.413 1.76129 11.5833 1.76129 10.1677 2.71612L4.33632 6.65204C3.18654 7.42773 2.5 8.71749 2.5 10.1056V17.8341C2.5 20.1312 4.36882 22 6.66589 22H18.3304C20.6274 22 22.4963 20.1312 22.4963 17.8341V10.1056C22.4963 8.78831 21.8764 7.55687 20.8299 6.77286ZM20.8299 17.8341C20.8299 19.2122 19.7084 20.3336 18.3304 20.3336H6.66589C5.28781 20.3336 4.16635 19.2122 4.16635 17.8341V10.1056C4.16635 9.27322 4.57794 8.4992 5.26781 8.03429L11.1001 4.09836C11.525 3.81091 12.0115 3.6676 12.4981 3.6676C12.9847 3.6676 13.4713 3.81091 13.8962 4.09836L19.7284 8.03429C20.4183 8.50003 20.8299 9.27322 20.8299 10.1056V17.8341Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default DashboardIcon;
